module.exports = __webpack_public_path__ + "dc63e39b22ec6437a3de24ab9657ee41.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/2096_teaser_image.jpg
// module id = 596
// module chunks = 0